import { Button, Result } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { Route, Redirect, useHistory } from "react-router-dom";
import useAuth from "src/shared/hooks/useAuth";

const ProtectedRoute = ({
  component: Component,
  protect,
  permission,
  ...rest
}: any) => {
  const { isLogedIn, hasPermission } = useAuth();
  const { t } = useTranslation();

  const {
    location: { pathname },
  } = useHistory();
  return (
    <Route
      {...rest}
      render={(props) => {
        if (protect && !isLogedIn && pathname != "/panel/login") {
          return (
            <Redirect
              to={{
                pathname: "/panel/login",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
        // else if (
        //   protect &&
        //   permission
        //   //  &&
        //   // !hasPermission([{
        //   //   route: permission.route,
        //   //   method: permission.method,
        //   // }])
        // ) {
        //   return (
        //     <Result
        //       status="403"
        //       title="403"
        //       subTitle={t("Sorry, you are not authorized to access this page.")}
        //       extra={<Button type="primary">{t("home")}</Button>}
        //     />
        //   );
        // }
        return <Component {...rest} {...props} />;
      }}
    />
  );
};

export default ProtectedRoute;
